import { isDefinedString, reduce } from "et3-type-guards";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import UserImageStatus from "./UserImageStatus";
import UserImageArrows from "./UserImageArrows";
import { CAMERA_SOLID } from "../../../../../../constants/picker-entries-constants";
import UserImageBanner from "./UserImageBanner";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";

const UserImage = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const pictures = reduce(
    () => getUserAdvancedStore().userData.get(userID).pictures,
    []
  );
  const currentIndex = reduce(
    () => getUserAdvancedStore().userAlbumIndex.get(),
    0
  );
  const { source } = getUserAdvancedStore().getImageData(
    pictures[currentIndex]
  );
  let currentSource = CAMERA_SOLID;
  if (pictures.length > 0) {
    currentSource = isDefinedString(source) ? source : CAMERA_SOLID;
  }
  const moreThanOnePicture = pictures.length > 0;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={224}
      height={303}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={224}
        height={230}
        fDirection="column-reverse"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          position: "relative"
        }}
        onClick={() => {}}
      >
        <UserImageBanner currentSource={currentSource} />
        <Et3Margin top={3} bottom={3} left={112} right={112} />
        <UserImageStatus />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={224}
        height={73}
        fDirection="column"
        alignItems="center"
        justifyContent="flex-end"
        color={colors.all.transparent}
        style={{
          borderRadius: 10
        }}
        onClick={() => {}}
      >
        <UserImageArrows
          moreThanOnePicture={moreThanOnePicture}
          currentIndex={currentIndex}
          imageArray={pictures}
          onNextPress={() => {
            const nextIndex = currentIndex + 1;
            if (nextIndex > pictures.length - 1) {
              getUserAdvancedStore().userAlbumIndex.set(pictures.length - 1);
              return;
            }
            getUserAdvancedStore().userAlbumIndex.set(nextIndex);
          }}
          onPreviousPress={() => {
            const previousIndex = currentIndex - 1;
            if (previousIndex <= 0) {
              getUserAdvancedStore().userAlbumIndex.set(0);
              return;
            }
            getUserAdvancedStore().userAlbumIndex.set(currentIndex - 1);
          }}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default UserImage;
